import { render } from "./StartingPage.vue?vue&type=template&id=5b78ff67"
import script from "./StartingPage.vue?vue&type=script&lang=js"
export * from "./StartingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__